<mat-form-field
  appearance="fill"
  class="filter-turnover-risk-form-field mat-form-field w-100"
>
  <mat-label>Turnover Risk</mat-label>
  <mat-select
    [formControl]="formControl"
    [multiple]="true"
    (selectionChange)="updateTurnoverRiskFilter()"
    data-cy="turnover-risk-filter"
  >
    @for (option of turnoverRiskOptions; track option) {
    <mat-option [value]="option.value">
      {{ option.label }}
    </mat-option>
    }
  </mat-select>
</mat-form-field>
